import React, { useState } from "react";
import Button from "../../../form/Button";
import useFetch from "../../../../hooks/useFetch";
import { getBlogList } from "../../../../services/BlogService";
import dayjs from "dayjs";
import { removeDuplicateFromArray, replaceOldData } from "../../../../helpers";
import EventItem from "./EventItem";

const SectionEvent = () => {
  const [filters, setFilters] = useState({
    limit: 6,
    sortQuery: "-createdAt",
    page: 1,
  });

  const {
    data: EventsData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-events-list", filters],
    fetchFunction: async () => {
      const res = await getBlogList({
        type: "event",
        upcomingEvent: true,
        ...filters,
      });
      if (res?.docs?.status === 200) {
        const eventArr = (res?.docs?.data || [])
          ?.filter((item) => item?.title)
          ?.map((item) => {
            return {
              ...item,
              _id: item?._id,
              date: `${dayjs(res?.data?.publishDate)?.format(
                "MMM DD, YYYY"
              )} - ${dayjs(res?.data?.publishEndDate)?.format("MMM DD, YYYY")}`,
              image: item?.image?.url,
              link: `/updates/${item?.slug || item?._id}`,
            };
          });

        const newArr = replaceOldData([...(EventsData?.data || [])], eventArr);

        return {
          ...res?.docs,
          data: removeDuplicateFromArray([...newArr, ...eventArr]),
        };
      } else {
        if (EventsData?.data?.length > 0) {
          return EventsData;
        } else {
          return res;
        }
      }
    },
  });

  const loadMoreEvents = (page) => {
    setFilters((pre) => ({ ...pre, page }));
  };

  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          {EventsData?.data?.length > 0 && (
            <div className="grid grid-cols-3 gap-x-6 gap-y-16">
              {EventsData?.data?.map((item, index) => (
                <EventItem key={index} data={item} />
              ))}
            </div>
          )}
          {filters?.page < EventsData?.metadata?.totalPages && (
            <div className="flex items-center justify-center mt-16">
              <Button
                buttonLabel={"Load More"}
                buttonClasses={
                  "!h-12 xl:!h-14 !rounded-full !px-6 xl:!px-10 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-60"
                }
                buttonLabelClasses={"!text-base xl:!text-xl"}
                buttonFunction={() => {
                  loadMoreEvents(EventsData?.metadata?.nextPage);
                }}
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SectionEvent;
